import { useEffect, useRef, useState } from "react";

import Guest1Img from "../../assets/images/conversations/ep-57-vijay-gokhale-guest.webp";
import Guest2Img from "../../assets/images/conversations/ep-57-ravin-mirchandani-guest.webp";
import ThumbImg  from "../../assets/images/conversations/057.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: vg-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .vg-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .vg-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .vg-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .vg-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .vg-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .vg-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vg-hero__title.vg-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .vg-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .vg-hero__spotify.vg-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .vg-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .vg-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .vg-hero__right.vg-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .vg-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .vg-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .vg-yt-thumb:hover img { opacity: 0.85; }
  .vg-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .vg-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .vg-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .vg-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .vg-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vg-body.vg-visible { opacity: 1; transform: translateY(0); }
  .vg-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .vg-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (2 guests)
  ══════════════════════════════════════ */
  .vg-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vg-guest.vg-visible { opacity: 1; transform: translateY(0); }
  .vg-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .vg-guest__grid {
    display: flex;
    justify-content: center;
    gap: 60px;
  }
  .vg-guest__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    max-width: 445px;
  }
  .vg-guest__photo-bg {
    width: 100%;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .vg-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .vg-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .vg-inner { padding-left: 32px; padding-right: 32px; }
    .vg-hero { padding-top: 32px; padding-bottom: 48px; }
    .vg-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .vg-hero__title { font-size: 24px; }
    .vg-hero__left { gap: 16px; }
    .vg-guest__title { font-size: 24px; margin-bottom: 24px; }
    .vg-guest__grid { gap: 20px; }
    .vg-guest__photo-bg { width: 100%; height: 300px; }
    .vg-guest__name { font-size: 24px; margin-top: 18px; }
    .vg-body__para { font-size: 14px; margin-bottom: 12px; }
    .vg-body { padding-bottom: 48px; }
    .vg-guest { padding-bottom: 48px; }
    .vg-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .vg-inner { padding-left: 16px; padding-right: 16px; }
    .vg-hero { padding-top: 51px; padding-bottom: 30px; }
    .vg-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .vg-hero__left { gap: 30px; }
    .vg-hero__title { font-size: 30px; }
    .vg-body__para { font-size: 16px; margin-bottom: 10px; }
    .vg-guest__title { font-size: 30px; margin-bottom: 20px; }
    .vg-guest__grid { flex-direction: column; gap: 30px; }
    .vg-guest__card { max-width: 100%; align-items: flex-start; }
    .vg-guest__photo-bg { width: 100%; height: 386px; }
    .vg-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .vg-body { padding-bottom: 30px; }
    .vg-guest { padding-bottom: 30px; }
    .vg-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vg-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "6sw_bDz-P7g";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="vg-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 57 Vijay Gokhale"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="vg-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 57 Vijay Gokhale thumbnail" />
      <div className="vg-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="vg-hero">
      <div className="vg-inner">
        <div className="vg-hero__grid">
          <div className="vg-hero__left">
            <h1 ref={titleRef} className="vg-hero__title">
              EP 57 | Navigating Geopolitics in a Shifting World Order | Vijay GOKHALE
            </h1>
            <div ref={spotifyRef} className="vg-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/2sJHuNlCqpLxC97yUpjtwf?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 57 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="vg-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="vg-body">
      <div className="vg-inner">
        <p className="vg-body__para">
          In this episode, Vijay Gokhale, former Indian Foreign Secretary, offers a nuanced analysis of the evolving dynamics of geopolitics and global trade. He examines China's strategic maneuvers in supply chain control, its negotiation strategies, and the broader implications for international diplomacy.
        </p>
        <p className="vg-body__para">
          The episode also evaluates the potential repercussions of Donald Trump's return to the U.S. presidency, considering its impact on global trade and geopolitical stability.
        </p>
        <p className="vg-body__para">
          Join us for an insightful conversation on the critical challenges and opportunities shaping the future of the global order.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="vg-guest">
      <div className="vg-inner">
        <h2 className="vg-guest__title">Our Guest</h2>
        <div className="vg-guest__grid">
          <div className="vg-guest__card">
            <div className="vg-guest__photo-bg">
              <img src={Guest1Img} alt="Vijay Gokhale" />
            </div>
            <p className="vg-guest__name">Vijay GOKHALE</p>
          </div>
          <div className="vg-guest__card">
            <div className="vg-guest__photo-bg">
              <img src={Guest2Img} alt="Ravin Mirchandani" />
            </div>
            <p className="vg-guest__name">Ravin MIRCHANDANI</p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep57VijayGokhale() {
  return (
    <>
      <style>{CSS}</style>
      <div className="vg-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}